import { PercentPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-activity-progress-report-chart',
    templateUrl: './activity-progress-report-chart.component.html',
    styleUrls: ['./activity-progress-report-chart.component.scss'],
    standalone: false
})
export class ActivityProgressReportChartComponent {
    @Input() data: any[];
    @Input() Alldata: any[];
    @Input() CustomColors: any = [];
    @Input() title: string = '';
    @Input() isChartShow: boolean = false;
    pipe: any = new PercentPipe('en-US');

    constructor() {}

    customizeTooltip = (arg: any) => {
        return {
            text: this.pipe.transform(arg.percent, '1.2-2'),
        };
    };

    ngOnInit(): void {
        //this.getAndSetUpChart();
    }
}
